import {
  Component,
  NgZone
} from "@angular/core";
import {
  NavController,
  NavParams,
  ToastController,
  ModalController
} from "ionic-angular";
import {
  APIServiceProvider
} from "./../../../common/services/api.service";
import {
  HelperServiceProvider
} from "./../../../common/services/helper.service";
import {
  Toast
} from "@ionic-native/toast";
import {
  CustomerModalPage
} from "../../../modals/customer/customer.modal";
import {
  OrderdetailsModalPage
} from "../../../modals/orderdetails/orderdetails.modal";
import {
  NotifyService
} from "../../../services/notify.service";

@Component({
  selector: "page-orderplaced",
  templateUrl: "orderplaced.html"
})
export class OrderplacedPage {
  public ordersData: any = [];
  public ordersApiResponse: any;
  private apiUrl: any = "orders/all";
  public postParams: any = {
    order_status: [1, 2],
    created_by: localStorage.getItem("manager_user_id")
  };

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public apiService: APIServiceProvider,
    public zone: NgZone,
    public toast: Toast,
    public helperService: HelperServiceProvider,
    public toastCtrl: ToastController,
    public modalController: ModalController,
    private notifyService: NotifyService
  ) {
    this.notifyService.orderPlaced.subscribe(() => {
      this.getOrdersPlaced();
    });
  }

  ionViewDidLoad() {
    this.getOrdersPlaced();
  }
ionViewWillEnter(){
  this.getOrdersPlaced();
}

  getOrdersPlaced(refresh ? ) {
    this.apiService.post(this.apiUrl, this.postParams).subscribe(data => {
      this.ordersData = data["data"]["data"];
      this.ordersApiResponse = data["data"];
      if (refresh) {
        refresh.complete();
      }
    });
  }

  doInfiniteScroll(infiniteScroll) {
    if (!this.ordersApiResponse.next_page_url ||
      this.ordersApiResponse.next_page_url === "" ||
      this.ordersApiResponse.next_page_url === null ||
      this.ordersApiResponse.next_page_url === "null"
    ) {
      infiniteScroll.complete();
      return;
    }
    this.apiService
      .post(this.apiUrl, this.postParams, this.ordersApiResponse.next_page_url)
      .subscribe(data => {
        this.ordersApiResponse = data["data"];
        this.ordersData = this.ordersData.concat(data["data"]["data"]);
        infiniteScroll.complete();
      });
  }

  showCustomerModel(order_id) {
    let modalObject = this.modalController.create(CustomerModalPage, {
      order_id: order_id
    });

    modalObject.present();
  }

  doRefresh(refresh) {
    this.getOrdersPlaced(refresh);
  }

  showOrderDetailsModal(order_id) {
    this.getOrderDetails(order_id).then(data => {
      let modalObject = this.modalController.create(OrderdetailsModalPage, {
        orderDetails: data
      });

      modalObject.present();
    });
  }

  getOrderDetails(order_id) {
    return new Promise((resolve, reject) => {
      const params = {
        order_id
      };
      this.apiService
        .post("orders/get-order-details", params)
        .subscribe(result => {
          resolve(result);
        });
    });
  }
}


// WEBPACK FOOTER //
// ./src/pages/orders/orderplaced/orderplaced.ts